<template>
	<div v-if="paymentClientToken && payPal" class="cog-paypal-payment" :class="{ 'simulate-payment': simulatePayment}">
		<el-tabs v-if="!payPalOnly" v-model="selectedPaymentMethod" type="border-card" :stretch="true">
			<el-tab-pane v-if="cardAvailable" name="Card">
				<span slot="label">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="23" height="23" fill="none">
						<path stroke="#234652" stroke-linecap="round" stroke-linejoin="round" d="M4.125 10.5H6.75M2 6.5h13m-12.227-3h11.454c.703 0 1.273.56 1.273 1.25v7.5c0 .69-.57 1.25-1.273 1.25H2.773c-.703 0-1.273-.56-1.273-1.25v-7.5c0-.69.57-1.25 1.273-1.25Z" />
					</svg>
					{{ cardTabText }}
				</span>
				<c-paypal-card
					ref="card"
					:key="cardFieldStyles"
					:create-order="createOrder"
					:pay-pal="payPal"
					:input-styles="inputStyles"
					:simulate-payment="simulatePayment"
					:generate-element-id="generateElementId"
					class="cog-payment-container"
					@ready="$emit('ready')"
				>
					<div :id="generateElementId('cog-card-number')" class="cog-input cog-input--full" :data-cognito-placeholder="resource('credit-card-number')">
						<div class="cog-input__placeholder" @click="$refs.card.initializeForm()"></div>
					</div>
					<div :id="generateElementId('cog-card-expiry')" class="cog-input cog-input--medium" :data-cognito-placeholder="resource('credit-card-expiration')">
						<div class="cog-input__placeholder" @click="$refs.card.initializeForm()"></div>
					</div>
					<div :id="generateElementId('cog-card-cvv')" class="cog-input cog-input--small" :data-cognito-placeholder="resource('credit-card-cvv')">
						<div class="cog-input__placeholder" @click="$refs.card.initializeForm()"></div>
					</div>
					<div :id="generateElementId('cog-zip-code')" class="cog-input cog-input--medium" :data-cognito-placeholder="zipPostalCodePlaceholder">
						<div class="cog-input__placeholder" @click="$refs.card.initializeForm()"></div>
					</div>
				</c-paypal-card>
				<div v-if="simulatePayment" class="simulate-trigger" @click="previewHandler"></div>
			</el-tab-pane>
			<el-tab-pane name="PayPal">
				<span slot="label">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 124 31" class="paypal-logo paypal-logo--light">
						<path fill="#003087" d="M46.42 6.9h-6.84a1 1 0 0 0-.94.8l-2.77 17.53a.58.58 0 0 0 .57.66h3.26a1 1 0 0 0 .94-.8l.75-4.73a1 1 0 0 1 .94-.8h2.16c4.51 0 7.11-2.18 7.78-6.5a5.249 5.249 0 0 0-.87-4.42c-.97-1.14-2.69-1.74-4.98-1.74Zm.79 6.4c-.38 2.45-2.25 2.45-4.07 2.45h-1l.73-4.58a.56.56 0 0 1 .56-.48h.47c1.24 0 2.4 0 3 .7a2.31 2.31 0 0 1 .31 1.91ZM66.86 13.22h-3.27a.59.59 0 0 0-.57.48l-.14.92-.23-.33c-.71-1-2.29-1.38-3.87-1.38a7.53 7.53 0 0 0-7.31 6.59 6.18 6.18 0 0 0 1.22 5 5.11 5.11 0 0 0 4.12 1.67 6.27 6.27 0 0 0 4.54-1.88l-.15.91a.57.57 0 0 0 .56.66h2.95a1 1 0 0 0 .94-.8l1.77-11.21a.56.56 0 0 0-.56-.63ZM62.3 19.6a3.66 3.66 0 0 1-3.7 3.12 2.53 2.53 0 0 1-2.71-3.18 3.65 3.65 0 0 1 3.67-3.15 2.77 2.77 0 0 1 2.18.89 2.848 2.848 0 0 1 .56 2.32ZM84.3 13.22H81a1 1 0 0 0-.79.42l-4.53 6.68-1.92-6.42a1 1 0 0 0-.91-.68h-3.23a.58.58 0 0 0-.55.76l3.63 10.63-3.41 4.81a.57.57 0 0 0 .47.9H73a.93.93 0 0 0 .78-.4l11-15.8a.569.569 0 0 0-.48-.9Z" />
						<path fill="#0070E0" d="M95.2 6.9h-6.84a1 1 0 0 0-.94.8l-2.77 17.53a.58.58 0 0 0 .57.66h3.51a.66.66 0 0 0 .65-.56l.79-5a1 1 0 0 1 .94-.8h2.16c4.51 0 7.1-2.18 7.78-6.5a5.243 5.243 0 0 0-.87-4.42C99.21 7.5 97.49 6.9 95.2 6.9Zm.79 6.4c-.38 2.45-2.25 2.45-4.06 2.45h-1l.73-4.58a.56.56 0 0 1 .56-.48h.47c1.24 0 2.4 0 3 .7A2.31 2.31 0 0 1 96 13.3h-.01ZM115.64 13.22h-3.27a.568.568 0 0 0-.56.48l-.15.92-.23-.33c-.71-1-2.29-1.38-3.87-1.38a7.532 7.532 0 0 0-7.31 6.59 6.17 6.17 0 0 0 1.22 5 5.134 5.134 0 0 0 4.13 1.67 6.266 6.266 0 0 0 4.53-1.88l-.15.91a.593.593 0 0 0 .135.46.58.58 0 0 0 .435.2h3a.938.938 0 0 0 .93-.8l1.78-11.21a.578.578 0 0 0-.373-.594.58.58 0 0 0-.247-.036Zm-4.56 6.38a3.659 3.659 0 0 1-3.7 3.12 2.759 2.759 0 0 1-2.2-.88 2.816 2.816 0 0 1-.51-2.3 3.65 3.65 0 0 1 3.67-3.15 2.77 2.77 0 0 1 2.18.89c.255.323.438.698.535 1.098.096.401.105.818.025 1.222ZM119.5 7.38l-2.81 17.85a.593.593 0 0 0 .135.46.582.582 0 0 0 .435.2h2.82a.998.998 0 0 0 .94-.8l2.77-17.54a.592.592 0 0 0-.135-.46.581.581 0 0 0-.435-.2h-3.16a.58.58 0 0 0-.56.49Z" />
						<path fill="#003087" d="M7.47 29.3 8 26H1.27L5.13 1.49a.33.33 0 0 1 .32-.27h9.38c3.11 0 5.26.65 6.38 1.93a4.43 4.43 0 0 1 1 1.91 6.889 6.889 0 0 1 0 2.65v.75l.53.3c.401.201.76.476 1.06.81a3.85 3.85 0 0 1 .87 1.94 8.34 8.34 0 0 1-.13 2.81 9.931 9.931 0 0 1-1.15 3.18 6.612 6.612 0 0 1-1.82 2 7.382 7.382 0 0 1-2.46 1.11c-1.004.25-2.035.372-3.07.36h-.73a2.24 2.24 0 0 0-1.43.52 2.29 2.29 0 0 0-.75 1.33v.3l-.92 5.86-.05.21a.27.27 0 0 1-.05.13.19.19 0 0 1-.1 0l-4.54-.02Z" />
						<path fill="#0070E0" d="M23.25 7.81c0 .18-.06.37-.09.55-1.24 6.35-5.47 8.55-10.88 8.55H9.53A1.33 1.33 0 0 0 8.21 18L6.8 27l-.4 2.53a.71.71 0 0 0 .7.81H12a1.17 1.17 0 0 0 1.16-1l.05-.24.92-5.84.06-.32a1.17 1.17 0 0 1 1.16-1h.73c4.72 0 8.43-1.92 9.51-7.47.45-2.33.22-4.26-1-5.63a4.642 4.642 0 0 0-1.34-1.03Z" />
						<path fill="#242E65" d="M22 7.3c-.19-.06-.384-.11-.58-.15a6.18 6.18 0 0 0-.62-.12 15.31 15.31 0 0 0-2.43-.18H11c-.177 0-.352.04-.51.12a1.15 1.15 0 0 0-.65.88l-1.56 9.9-.05.29a1.33 1.33 0 0 1 1.32-1.13h2.75c5.41 0 9.64-2.2 10.88-8.55.04-.182.07-.365.09-.55a8.515 8.515 0 0 0-1-.43L22 7.3Z" />
						<path fill="#003087" d="M9.82 7.85a1.15 1.15 0 0 1 .65-.88 1.27 1.27 0 0 1 .51-.12h7.35c.814-.005 1.626.056 2.43.18.21 0 .42.07.62.12.196.04.39.09.58.15l.28.08c.341.124.675.268 1 .43.36-2.34 0-3.94-1.28-5.39C20.68.97 18.04.15 14.81.15H5.45a1.35 1.35 0 0 0-1.33 1.13L.22 26A.81.81 0 0 0 1 27h5.8l1.46-9.23 1.56-9.92Z" />
					</svg>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 115 28" class="paypal-logo paypal-logo--dark">
						<path d="M88.22 6.193h-6.302a.875.875 0 0 0-.865.74L78.504 23.08a.525.525 0 0 0 .52.607h3.233c.301 0 .559-.219.605-.517l.723-4.578a.875.875 0 0 1 .865-.739h1.995c4.15 0 6.546-2.007 7.172-5.986.282-1.74.012-3.107-.804-4.065-.896-1.052-2.484-1.609-4.593-1.609Zm.728 5.898c-.345 2.26-2.072 2.26-3.744 2.26h-.95l.666-4.22a.526.526 0 0 1 .52-.443h.435c1.138 0 2.212 0 2.766.647.332.388.432.962.306 1.756ZM43.271 6.193H36.97a.876.876 0 0 0-.865.74L33.556 23.08a.525.525 0 0 0 .519.607h3.009c.43 0 .797-.313.865-.738l.688-4.357a.875.875 0 0 1 .864-.739h1.995c4.15 0 6.546-2.007 7.173-5.986.282-1.74.011-3.107-.804-4.065-.897-1.052-2.486-1.609-4.594-1.609ZM44 12.091c-.345 2.26-2.073 2.26-3.743 2.26h-.951l.666-4.22a.525.525 0 0 1 .52-.443h.435c1.138 0 2.212 0 2.766.647.331.388.432.962.307 1.756ZM62.108 12.019H59.09a.525.525 0 0 0-.519.443l-.133.843-.21-.305c-.654-.948-2.11-1.265-3.565-1.265-3.334 0-6.182 2.525-6.736 6.066-.29 1.766.12 3.455 1.123 4.633.92 1.082 2.235 1.533 3.8 1.533 2.688 0 4.178-1.725 4.178-1.725l-.134.838a.525.525 0 0 0 .519.607h2.717c.431 0 .797-.313.865-.738l1.631-10.323a.525.525 0 0 0-.518-.607Zm-4.206 5.87c-.291 1.722-1.66 2.88-3.406 2.88-.876 0-1.576-.282-2.027-.815-.446-.528-.614-1.28-.472-2.118.271-1.707 1.662-2.901 3.382-2.901.856 0 1.552.283 2.011.821.463.542.644 1.299.512 2.133ZM107.056 12.019h-3.017a.525.525 0 0 0-.519.443l-.133.843-.211-.305c-.653-.948-2.11-1.265-3.564-1.265-3.334 0-6.182 2.525-6.736 6.066-.289 1.766.12 3.455 1.123 4.633.92 1.082 2.235 1.533 3.8 1.533 2.688 0 4.179-1.725 4.179-1.725l-.135.838a.524.524 0 0 0 .519.607h2.717a.875.875 0 0 0 .865-.738l1.632-10.323a.526.526 0 0 0-.52-.607Zm-4.205 5.87c-.291 1.722-1.66 2.88-3.406 2.88-.875 0-1.576-.282-2.026-.815-.447-.528-.615-1.28-.473-2.118.272-1.707 1.662-2.901 3.381-2.901.857 0 1.553.283 2.013.821.462.542.643 1.299.511 2.133ZM78.18 12.019h-3.033a.877.877 0 0 0-.725.384l-4.184 6.157-1.773-5.917a.876.876 0 0 0-.839-.624h-2.981a.525.525 0 0 0-.498.694l3.34 9.797-3.141 4.429a.525.525 0 0 0 .429.828h3.03c.287 0 .556-.14.72-.376l10.087-14.548a.525.525 0 0 0-.432-.824ZM110.614 6.637l-2.587 16.444a.525.525 0 0 0 .519.606h2.601a.875.875 0 0 0 .865-.738l2.55-16.149a.524.524 0 0 0-.518-.606h-2.911a.524.524 0 0 0-.519.443Z" fill="#fff" />
						<path opacity=".45" d="M21.144 7.055c.337-2.16-.003-3.63-1.168-4.962C18.694.628 16.377 0 13.413 0H4.808c-.605 0-1.121.442-1.216 1.043L.01 23.83a.74.74 0 0 0 .73.856H6.05l-.367 2.332a.647.647 0 0 0 .638.748H10.8c.53 0 .981-.386 1.064-.911l.044-.229.843-5.364.055-.297a1.078 1.078 0 0 1 1.063-.912h.67c4.338 0 7.734-1.767 8.726-6.88.415-2.135.2-3.918-.896-5.172a4.269 4.269 0 0 0-1.225-.947Z" fill="#fff" />
						<path opacity=".45" d="M21.144 7.055c.337-2.16-.003-3.63-1.168-4.962C18.694.628 16.377 0 13.413 0H4.808c-.605 0-1.121.442-1.216 1.043L.01 23.83a.74.74 0 0 0 .73.856H6.05L7.385 16.2l-.041.266c.094-.6.605-1.043 1.211-1.043h2.525c4.959 0 8.842-2.02 9.976-7.863.033-.173.062-.34.088-.505Z" fill="#fff" />
						<path d="M8.819 7.083a1.08 1.08 0 0 1 1.064-.911h6.745c.799 0 1.544.052 2.225.162a9.777 9.777 0 0 1 1.103.246 6.062 6.062 0 0 1 1.188.475c.338-2.16-.002-3.63-1.167-4.961C18.694.628 16.377 0 13.413 0H4.808c-.605 0-1.121.442-1.216 1.043L.01 23.83a.74.74 0 0 0 .73.856H6.05L7.385 16.2 8.82 7.083Z" fill="#fff" />
					</svg>
				</span>
				<c-paypal-button
					v-show="!orderApproved"
					:create-order="createOrder"
					:on-approve="onApprove"
					:on-error="onError"
					:pay-pal="payPal"
					:generate-element-id="generateElementId"
					:funding-source="payPal.FUNDING.PAYPAL"
					:disable-popup="disablePopup"
					@click="$emit('focus')"
					@ready="$emit('ready-paypal')"
				>
					<div class="help-text">{{ payPalHelpText }}</div>
					<div :id="generateElementId('paypal-button-container')"></div>
				</c-paypal-button>
				<div v-if="simulatePayment" class="simulate-trigger" @click="previewHandler"></div>
			</el-tab-pane>
			<el-tab-pane v-if="isVenmoVisible" name="Venmo">
				<span slot="label">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 24" class="venmo-logo">
						<path fill="#008CFF" d="M13.96 1.492c.471.981.772 2.173.772 3.923 0 3.196-2.274 7.885-4.116 10.868L8.643.51.5 1.278l3.73 22.166h9.3c4.072-5.328 9.089-12.915 9.089-18.757 0-1.83-.387-3.28-1.244-4.688L13.96 1.492ZM36.386.084c-8.488 0-12.604 7.333-12.604 14.238 0 5.329 2.53 9.59 9.602 9.59 2.788 0 5.66-.596 7.502-1.491l.985-6.648c-2.615 1.32-4.628 1.831-6.73 1.831-1.93 0-3.385-1.02-3.385-3.623 4.374-.042 11.916-1.831 11.916-7.672 0-3.623-2.614-6.225-7.286-6.225ZM31.929 9.76c.215-2.556 2.184-4.346 3.685-4.346.858 0 1.585.51 1.585 1.534.001 2.131-3.771 2.812-5.27 2.812ZM61.727.085c-3.042 0-5.186 1.153-6.815 2.217L54.825.468h-6.901L44.28 23.445h7.973l2.529-16.112c.685-.342 1.715-.81 2.742-.81.774 0 1.417.254 1.417 1.278 0 .426-.13 1.194-.173 1.576l-2.228 14.068h7.929l2.444-15.347c.13-.808.26-2.044.26-2.897 0-3.07-1.418-5.117-5.447-5.116ZM98.085.084c-2.956 0-5.1.897-7.372 2.515-.817-1.45-2.444-2.515-4.93-2.514-2.873 0-5.014 1.153-6.601 2.302L78.968.468H72.15l-3.642 22.977h7.97l2.53-16.112c.686-.342 1.714-.81 2.743-.81.77 0 1.414.254 1.414 1.407 0 .297-.085.766-.127 1.15l-2.271 14.365h7.929l2.528-16.112c.731-.385 1.716-.81 2.7-.81.774 0 1.418.254 1.418 1.407 0 .297-.088.766-.13 1.15l-2.271 14.365h7.931l2.441-15.347c.129-.808.259-2.044.259-2.897 0-3.07-1.416-5.117-5.488-5.117Zm20.284 0c-8.874 0-12.731 6.78-12.731 14.026 0 5.498 2.229 9.89 8.958 9.89 9.088 0 12.903-7.417 12.903-14.579.001-5.414-2.443-9.337-9.13-9.337Zm-2.659 17.82c-1.413 0-2.014-1.322-2.014-3.455 0-2.813.642-8.311 3.772-8.311 1.413 0 1.885 1.278 1.885 3.155.001 2.813-.685 8.61-3.643 8.61Z" />
					</svg>
				</span>
				<c-paypal-button
					v-show="!orderApproved"
					:disable-popup="simulatePayment"
					:create-order="createOrder"
					:on-approve="onApprove"
					:pay-pal="payPal"
					:generate-element-id="generateElementId"
					:funding-source="payPal.FUNDING.VENMO"
					@click="$emit('focus')"
					@error-rendering-button="venmoLoadingError"
					@ready="$emit('ready-venmo')"
				>
					<div class="help-text">{{ venmoHelpText }}</div>
					<div :id="generateElementId('venmo-button-container')"></div>
				</c-paypal-button>
				<div v-if="simulatePayment" class="simulate-trigger" @click="previewHandler"></div>
			</el-tab-pane>
		</el-tabs>
		<div v-else type="border-card" :stretch="true">
			<c-paypal-button
				v-show="!orderApproved"
				:disable-popup="simulatePayment"
				:create-order="createOrder"
				:on-approve="onApprove"
				:pay-pal="payPal"
				:generate-element-id="generateElementId"
				:funding-source="payPal.FUNDING.PAYPAL"
				@click="$emit('focus')"
				@ready="$emit('ready-paypal')"
			>
				<div class="help-text">{{ payPalHelpText }}</div>
				<div :id="generateElementId('paypal-button-container')"></div>
			</c-paypal-button>
		</div>
		<c-paypal-payer
			v-show="orderApproved && selectedPaymentMethod != 'Card'"
			:payment-method="selectedPaymentMethod"
			:identifier="payerInfo"
			:enabled="!simulatePayment"
			:change-button-text="changeText"
			@change="internalOrderApproved = false; $emit('focus')"
		></c-paypal-payer>
	</div>
</template>

<script lang="ts">
	import Vue, { defineComponent, inject, ref } from 'vue';
	import CPayPalCard from './PayPalCard';
	import CPayPalButton from './PayPalButton';
	import CPayPalPayer from './PayPalPayer.vue';
	import { FriendlyError } from '../../framework/logging/error';
	import { ensurePayPalSdk } from './PayPalSdkLoader';
	import { Tabs, TabPane } from '@cognitoforms/element-ui';
	import ToastMessage from '../ToastMessage';
	import type PaymentService from 'src/web-api/payment-service';
	import type Log from 'src/framework/logging/log';
	import type { FormSession } from 'src/web-api/form-session';
	import type { VueModel } from '@cognitoforms/vuemodel/@types/vue-model';
	import type { CultureInfo } from '@cognitoforms/model.js/@types/globalization';
	import type { PayPalNamespace } from '@paypal/paypal-js';

	Vue.use(Tabs);
	Vue.use(TabPane);

	export default defineComponent({
		name: 'CPayPalPayment',
		components: {
			'c-paypal-card': CPayPalCard,
			'c-paypal-button': CPayPalButton,
			'c-paypal-payer': CPayPalPayer
		},
		props: {
			entry: { type: Object, required: true },
			apiKey: { type: String, required: true },
			currencyCode: { type: String, default: 'USD' },
			paymentRequired: { type: Boolean, default: false },
			inputStyles: { type: Object, default: null },
			disablePopup: { type: Boolean, default: false }
		},
		setup() {
			const resource = inject<VueModel['getResource']>('$resource');
			const culture = inject<CultureInfo>('$culture', {} as CultureInfo);
			const log = inject<Log>('log');
			const session = inject<FormSession>('session');
			const paymentService = inject<PaymentService>('paymentService');
			return {
				resource,
				culture,
				log,
				session,
				paymentService: paymentService,
				creatingToken: ref(false),
				payPal: ref<PayPalNamespace>(null),
				selectedPaymentMethod: ref(''),
				orderId: ref<string>(null),
				internalOrderApproved: ref(false),
				payerInfo: ref(''),
				payerInfoToken: ref<string>(null),
				browserEnabledVenmo: ref(true),
				mountDate: ref(Date.now().toString()),
				paymentClientToken: ref<string>(null)
			};
		},
		computed: {
			orderAmount() {
				return this.entry.Order.OrderAmount;
			},
			currency() {
				return this.currencyCode ? this.currencyCode.toLowerCase() : null;
			},
			cardAvailable() {
				return this.payPal && this.payPal.HostedFields.isEligible();
			},
			venmoEligible() {
				return this.payPal.isFundingEligible(this.payPal.FUNDING.VENMO);
			},
			isVenmoVisible() {
				return this.venmoEligible && this.browserEnabledVenmo;
			},
			payPalOnly() {
				return !this.cardAvailable && !this.venmoEligible;
			},
			paypalLogo() {
				return require('src/assets/graphics/paypal-logo.svg');
			},
			zipPostalCodePlaceholder() {
				if (this.culture.name === 'en-US')
					return this.resource('address-zip-code');
				else
					return this.resource('credit-card-postalcode');
			},
			cardFieldStyles() {
				return this.inputStyles.useFormTheme ? this.inputStyles.lineHeight + this.inputStyles.fontFamily + this.inputStyles.fontSize + this.inputStyles.fontWeight + this.inputStyles.placeholderColor : null;
			},
			simulatePayment() {
				return this.session.flags.simulatePayment;
			},
			orderApproved() {
				return this.internalOrderApproved;
			},
			payPalHelpText() {
				return this.resource('paypal-help-text');
			},
			venmoHelpText() {
				return this.resource('venmo-help-text');
			},
			cardTabText() {
				return this.resource('card-tab');
			},
			changeText() {
				return this.resource('change-button');
			}
		},
		watch: {
			cardAvailable: {
				handler(value) {
					this.selectedPaymentMethod = value ? 'Card' : 'PayPal';
				},
				immediate: true
			},
			selectedPaymentMethod(newVal, oldVal) {
				this.$emit('focus');
				if (this.simulatePayment)
					return;
				if (oldVal === 'Card' && this.$refs.card)
					this.$refs.card.clear();
				if (oldVal === 'PayPal' || oldVal === 'Venmo')
					this.internalOrderApproved = false;
			}
		},
		async mounted() {
			const clientConfig = await this.paymentService.getPayPalConfig();
			this.paymentClientToken = clientConfig.ClientToken;

			if (!this.paymentClientToken) {
				console.error('paymentClientToken is null');
			}
			else {
				ensurePayPalSdk(
					this.apiKey,
					clientConfig.TrackingId,
					clientConfig.MerchantId,
					this.paymentClientToken,
					this.currency,
					this.culture.name
				)
					.then(payPal => {
						this.payPal = payPal as PayPalNamespace;
					})
					.catch(error => {
						this.log.warn('Loading the PayPal SDK failed.');
						// Re-throw the original error
						throw error;
					});
			}
		},
		methods: {
			setSelectedPaymentMethod(value) {
				this.selectedPaymentMethod = value;
			},
			createOrder() {
				return this.paymentService.createOrder(this.orderAmount, this.currencyCode, this.session.formId, this.paymentClientToken)
					.then(result => {
						this.orderId = result.response.data.order.Id;
						this.payerInfoToken = result.response.data.encryptedString;
						return this.orderId;
					});
			},
			getIdentifier() {
				return this.paymentService.getIdentifier(this.payerInfoToken, this.selectedPaymentMethod, this.paymentClientToken)
					.then(result => {
						if (result.response.data)
							this.payerInfo = result.response.data;
						else {
							if (this.selectedPaymentMethod === 'Venmo')
								this.payerInfo = this.resource('connected-to-venmo');
							else
								this.payerInfo = this.resource('connected-to-paypal');
						}
						return this.payerInfo;
					});
			},
			onApprove(data) {
				this.internalOrderApproved = true;
				if (this.selectedPaymentMethod !== 'Card')
					this.getIdentifier();
			},
			onError(err) {
				throw err;
			},
			async createToken() {
				if (this.simulatePayment)
					return {
						Type: 'Order',
						Token: 'previewToken',
						DateCreated: new Date(),
						Status: this.paymentRequired ? 'PendingPayment' : null,
						SaveForFutureUse: false,
						IsLive: false
					};

				if (!this.orderApproved && this.selectedPaymentMethod === 'Venmo')
					throw new FriendlyError(this.venmoHelpText);

				if (!this.orderApproved && this.selectedPaymentMethod === 'PayPal')
					throw new FriendlyError(this.payPalHelpText);

				if (this.selectedPaymentMethod !== 'Card') {
					return {
						Type: 'Order',
						Token: this.orderId,
						DateCreated: new Date(),
						Status: this.paymentRequired ? 'PendingPayment' : null,
						SaveForFutureUse: false,
						IsLive: true
					};
				}

				if (this.creatingToken) {
					// If we're currently in process of creating a token, then wait until complete
					await new Promise<void>((resolve, reject) => {
						let createTokenAttempts = 0;
						const createTokenInterval = setInterval(() => {
							if (!this.creatingToken) {
								clearInterval(createTokenInterval);
								resolve();
							}
							else if (++createTokenAttempts > 10) {
								clearInterval(createTokenInterval);
								reject(new Error(this.resource('order-submit-timeout')));
							}
						}, 100);
					});
				}

				let response = null;

				// Signal that we're creating a token so that we don't double-up requests
				this.creatingToken = true;
				try {
					/**
					 * @type {CPayPalCard}
					 */
					const payPalCard = this.$refs.card;
					if (!payPalCard) {
						throw new Error('Couldn\'t find PayPal payment form.');
					}

					response = await payPalCard.tokenize();
					if (response.liabilityShift && response.liabilityShift !== 'POSSIBLE' && response.liabilityShift !== 'YES')
						throw new FriendlyError(this.resource('payment-declined') + ': ' + this.resource('credit-card-authentication-failed'));
				}
				catch (e) {
					this.creatingToken = false;
					this.log.error(e, { method: 'PayPalPayment.createToken' });

					// If it's an error
					if (Object.prototype.toString.call(e) === '[object Error]' || (typeof e.message === 'string' && typeof e.stack === 'string')) {
						e.log = false;
						throw e;
					}
					else {
						let message = 'Unknown error';
						if (e)
							message = this.resource('credit-card-invalid');
						if (!message && e.message)
							message = e.message;
						throw new FriendlyError(message);
					}
				}

				// Signal that we're done creating the token
				this.creatingToken = false;

				return {
					Type: 'Order',
					Token: response.orderId,
					DateCreated: new Date(),
					Status: this.paymentRequired ? 'PendingPayment' : null,
					SaveForFutureUse: false,
					IsLive: true,
					Card: {
						Brand: response.card?.brand,
						Last4: response.card?.last_digits
					}
				};
			},
			previewHandler() {
				if (this.simulatePayment) {
					ToastMessage(this.session.formId, { type: 'error', message: 'Payment is disabled while previewing.', duration: 3500 });
				}
			},
			venmoLoadingError() {
				this.browserEnabledVenmo = false;
			},
			generateElementId(idString) {
				return idString + '-' + this.mountDate;
			}
		}
	});
</script>

<style lang="scss">
#{$specificity-base} {

	:not(.cog-cognito--chameleon) .cog-paypal-payment {

		.cog-input {
			height: calc((var(--input__line-height, 1.3) * var(--font-size)) + (var(--input__padding-v) * 2) + 2px);

			div {
				height: 100%;
			}
		}
	}

	.cog-cognito--chameleon .cog-paypal-payment {

		.el-tabs__item[aria-controls='pane-Card'] {
			font-family: initial;
		}

		.cog-input {
			height: calc((var(--input__line-height, 1.3) * 16px) + (var(--gutter) / 4));
		}
	}

	.cog-paypal-payment {

		.el-tabs {

			&__header {
				margin-bottom: calc(var(--gutter) / 2);
			}

			&__nav {
				display: flex;
				background: var(--input__background-color);
				border-radius: var(--input__border-radius);
			}

			&__item {
				display: flex;
				align-items: center;
				flex-basis: 50%;
				justify-content: center;
				min-height: 40px;
				max-height: 60px;
				border: 1px solid rgba(black, 20%);
				margin-right: -1px;
				padding: calc(var(--input__padding-v) * 1.5) 0;
				cursor: pointer;

				&:first-child {
					border-radius: var(--input__border-radius) 0 0 var(--input__border-radius);
				}

				&:last-child {
					border-radius: 0 var(--input__border-radius) var(--input__border-radius) 0;
				}

				&:not(.is-active, :first-child, :last-child) {
					border-right-color: transparent;
					border-left-color: transparent;
				}

				@media (min-width: 550px) {
					padding: calc(var(--input__padding-v) * 1.5) calc(var(--input__padding-h) * .5);
				}

				@media (min-width: 675px) {
					padding: calc(var(--input__padding-v) * 1.5) var(--input__padding-h);
				}

				&[aria-controls='pane-Card'] {
					color: var(--color);
					font-family: var(--button-primary__font-family, inherit);
					font-size: 17px;

					@media (min-width: 525px) and (max-width: 618px) {
						font-size: 1rem;
					}

					svg {
						vertical-align: text-bottom;
						stroke-width: var(--icon-weight);

						path {
							stroke: currentcolor;
						}
					}
				}

				&.is-active {
					z-index: $z-1;
					border-color: var(--highlight);
					cursor: default;
					color: var(--highlight);
				}

				&:focus:not(.is-disabled) {
					z-index: $z-1;
					border-color: var(--highlight);
					box-shadow: inset 0 0 0 1px var(--highlight);
				}

				span {
					text-align: center;
				}

				.paypal-logo {
					width: 100%;
					max-width: 85px;

					&--light {
						display: block;
					}

					&--dark {
						display: none;
					}
				}

				.venmo-logo {
					display: block;
					width: 100%;
					max-width: 70px;
					padding: 0 2px;
				}
			}

			&__content {

				.el-tab-pane {

					> div:first-child {
						animation: fade-in .5s forwards;
					}
				}

				@keyframes fade-in {

					from {
						opacity: 0;
					}

					to {
						opacity: 1;
					}
				}
			}
		}

		.cog-payment-container {
			display: flex;
			flex-wrap: wrap;
			gap: calc(var(--gutter) / 2);

			.cog-input--full {
				flex: 0 1 100%;
			}

			.cog-input--medium {
				flex: 1 0 7em;
			}

			.cog-input--small {
				flex: 1 0 5em;
			}
		}

		.cog-input {
			background: var(--input__background-color);
			border-width: var(--input__border-width-top, var(--input__border-width)) var(--input__border-width-right, var(--input__border-width)) var(--input__border-width-bottom, var(--input__border-width)) var(--input__border-width-left, var(--input__border-width));
			border-style: var(--input__border-style);
			border-color: var(--input__border-color);
			border-radius: var(--input__border-radius);
			box-shadow: var(--input__box-shadow);
			margin: 0;
			padding: 0 var(--input__padding-h);

			> div {
				display: none;
			}
		}

		.braintree-hosted-fields-focused {
			border-color: var(--highlight);
			box-shadow: var(--input-focus__box-shadow);
		}

		.help-text {
			margin-bottom: 8px;
			text-align: center;
		}

		[id^='paypal-button-container'],
		[id^='venmo-button-container'] {
			min-height: 45px;

			iframe {
				min-height: 45px;
			}

			> div {
				display: block !important;
			}
		}

		&.simulate-payment .el-tab-pane {
			position: relative;

			.simulate-trigger {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				top: 0;
				z-index: $paypal-button-overlay;
			}
		}
	}

	// Override input bg color for dark forms that arent fill, roundedfill, or underline style, otherwise you get white text and PayPal logo on a white background
	body:not(
		[data-field-style='fill'],
		[data-field-style='roundedfill'],
		[data-field-style='underline']
	) .cog-form--dark-background .cog-paypal-payment .el-tabs__nav {
		background: rgba(white, 10%);
	}

	.cog-form--dark-background .cog-paypal-payment {

		.el-tabs {

			&__item:not(.is-active) {
				border-color: rgba(white, 20%);

				&:not(.is-active, :first-child, :last-child) {
					border-right-color: transparent;
					border-left-color: transparent;
				}
			}
		}

		.paypal-logo {

			&--light {
				display: none;
			}

			&--dark {
				display: block;
			}

			[opacity='.45'] {
				opacity: .45;
			}
		}

		.venmo-logo {

			path {
				fill: white;
			}
		}
	}

	/* Fixes PayPal iframe adding extra space under the form */
	[id^='hosted-fields-tokenization-frame'] {
		position: absolute;
	}
}
</style>